import m from "../../geodata/es2015/dominicaHigh";
window.am4geodata_dominicaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/dominicaHigh.js
// module id = null
// module chunks = 